"use strict";
/**
 * @packageDocumentation
 * @module API-EVM-Constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVMConstants = void 0;
class EVMConstants {
}
exports.EVMConstants = EVMConstants;
EVMConstants.SECPCREDENTIAL = 9;
EVMConstants.IMPORTTX = 0;
EVMConstants.EXPORTTX = 1;
EVMConstants.SECPINPUTID = 5;
EVMConstants.ASSETIDLEN = 32;
EVMConstants.SECPXFEROUTPUTID = 7;
EVMConstants.LATESTCODEC = 0;
EVMConstants.ADDRESSLENGTH = 20;
//# sourceMappingURL=constants.js.map